import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-399-fill",
  "use": "icon-399-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-399-fill\" viewBox=\"0 0 16 16\" id=\"icon-399-fill\">\n  <path d=\"M.28 9.372a4.514 4.514 0 1 0 9.029 0c0-2.495-4.514-9.028-4.514-9.028S.28 6.877.28 9.372zM13.212 6.3s-2.569 3.718-2.569 5.138a2.569 2.569 0 1 0 5.138 0c0-1.42-2.569-5.138-2.569-5.138z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol